// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__WEZjb","widgetsContainer":"Dashboard_widgetsContainer__gGgP3","widgetsContainerHidden":"Dashboard_widgetsContainerHidden__2QLqO"};